export default {
    stateActiveStep: 0,
}
